<template> </template>

<script>
import axios from "axios";

export default {
  methods: {
    logOut() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/logout", {
          token: this.$store.getters.getToken
        })
        .then(response => {
          //Remove local storage because he/she want to logout
          if (localStorage.loginEmail && localStorage.loginPassword) {
            localStorage.removeItem("loginEmail");
            localStorage.removeItem("loginPassword");
          }

          if (this.$store.getters.getIsAppState === true) {
            this.$store.commit("logout");
            this.$router.push({ path: "/mobile/app" });
          } else {
            this.$store.commit("logout");
            this.$router.push({ path: "/" });
          }
        })
        .catch(error => {
          // this.$store.commit("loginFailed", {error});
          this.$store.commit("logout");
          this.$router.push({ path: "/" });
        });
    }
  },
  created: function() {
    this.logOut();
  }
};
</script>
